import { render, staticRenderFns } from "./chatBox.vue?vue&type=template&id=c66a6ac2&scoped=true&"
import script from "./chatBox.vue?vue&type=script&lang=js&"
export * from "./chatBox.vue?vue&type=script&lang=js&"
import style0 from "./chatBox.vue?vue&type=style&index=0&id=c66a6ac2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66a6ac2",
  null
  
)

export default component.exports